import classes from './Footer.module.css';

function Footer(props) {
    return (
        <footer className={classes.footer} style={{ backgroundColor: props.bgColor }} />
    );
}

export default Footer;